
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RoutesPath } from '../../../../../shared/constants/routes-path';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-eligible',
  imports: [TranslateModule],
  templateUrl: './not-eligible.component.html',
  styleUrl: './not-eligible.component.scss'
})
export class NotEligibleComponent {
  @Input() reason: 'nonMember' | 'underAuthority' | 'nonCommercial' = 'nonMember';

  constructor(
    private router: Router
  ) {

  }
  // This method is used to goto contact us
  gotoContactUs() {
    this.router.navigate([RoutesPath.CONTACT_US])
  }
}
